import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';

import { COMPANY_QUERY_KEY } from '../types';

export const deleteCompany = async (companyId: number) => {
  await restoreURL().patch(`${API_CTX}/companies/${companyId}`, {
    status: 'DELETED',
  });
};

export const useDeleteCompany = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(COMPANY_QUERY_KEY);
      toast.success(`The company was deleted successfully`);

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: Error) => {
      toast.error(`An error occurs: ${error.message}`);
    },
    mutationFn: (companyId: number) => {
      return deleteCompany(companyId);
    },
  });
};
